import { subsPresetsGenerator } from '../../../utils/subs';
import { GLOBAL_EXPORT_BUTTON_ENABLED } from '../../../constants/user';

export const INITIAL_FILTERS_STATE = {
  sort_by: 'title',
  order: 'asc',
};

export const SOURCE_PRESETS_PAGE_INFO = {
  title: 'Source Presets',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
];

const TYPES = [
  {
    value: '',
    label: 'None',
  },
  { value: 'r', label: 'Recommended' },
  { value: 'i', label: 'Integrated' },
  { value: 't', label: 'Template' },
];

export const SOURCE_PRESETS_TYPES = {
  '': 'None',
  r: 'Recommended',
  i: 'Integrated',
  t: 'Template',
};

export const SOURCE_PRESETS_ROLES = [
  {
    value: '',
    label: 'None',
  },
  { value: 'cid', label: 'Campaign ID' },
  { value: 'pubid', label: 'Publisher ID' },
  { value: 'pid', label: 'Placement ID' },
  { value: 'aid', label: 'Ad ID' },
  { value: 'gid', label: 'Ad group ID' },
  { value: 'rt_source', label: 'RT source' },
  { value: 'rt_medium', label: 'RT medium' },
  { value: 'rt_campaign', label: 'RT campaign' },
  { value: 'rt_adgroup', label: 'RT adgroup' },
  { value: 'rt_ad', label: 'RT ad' },
  { value: 'rt_placement', label: 'RT placement' },
  { value: 'rt_keyword', label: 'RT keyword' },
];

const FORMATS = [
  'pop',
  'display',
  'in-app',
  'redirect',
  'native',
  'push',
  'appwall',
  'rich-media',
  'in-banner',
  'video',
  'in-stream',
  'interstitial',
  'playable-ads',
  'floating-ads',
  'overlays',
  'audio',
  'carousel',
  'abstract',
  'dialog',
  'overlay',
  'text',
  'search',
  'blind-skimmed-ads',
  'click-under',
  'zero-click',
  'widgets',
];

export const SOURCE_PRESETS_FORM_INITIAL_DATA = {
  // main
  title: '',
  url: '',
  type: '',
  logo: '',
  formats: [],
  presetCategories: [],
  comment: '',
  // integrations
  alias: '',
  integration_types: {
    cost_update: false,
    pause_campaign: false,
    black_list_placement: false,
    pause_creative: false,
  },
  // contact
  contact: {
    person: '',
    email: '',
    phone: '',
    messenger: '',
  },
  referral_link: '',
  // settings
  postback_url: '',
  postback_pixel: '',
  imp_id: '',
  imp_cost_id: '',
  ref_id: '',
  cost_id: '',
  // subs
  subs: subsPresetsGenerator(),
};

export const getSourcePresetsMainFields = (categoriesOptions = []) => [
  {
    type: 'textField',
    label: 'Title',
    name: 'title',
    placeholder: 'Title',
  },
  {
    type: 'textField',
    label: 'Url',
    name: 'url',
    placeholder: 'Url',
  },
  {
    type: 'select',
    label: 'Type',
    name: 'type',
    placeholder: 'Type',
    options: [
      ...TYPES,
    ],
    className: 'select',
  },
  {
    type: 'textField',
    label: 'Logo',
    name: 'logo',
    placeholder: 'Logo',
  },
  {
    type: 'multiselect',
    label: 'Formats',
    name: 'formats',
    placeholder: 'Formats',
    options: [
      ...FORMATS,
    ],
    className: 'select',
  },
  {
    type: 'multiselect',
    label: 'Preset categories',
    name: 'presetCategories',
    placeholder: 'Preset categories',
    options: categoriesOptions,
    className: 'select',
  },
  {
    type: 'textField',
    label: 'Comment',
    name: 'comment',
    placeholder: 'Comment',
  },
];

export const SOURCE_PRESETS_INTEGRATIONS_FIELDS = [
  {
    type: 'textField',
    label: 'Alias',
    name: 'alias',
    placeholder: 'Alias',
  },
  {
    type: 'switch',
    label: 'Cost update',
    name: 'integration_types.cost_update',
  },
  {
    type: 'switch',
    label: 'Pause campaign',
    name: 'integration_types.pause_campaign',
  },
  {
    type: 'switch',
    label: 'Black list placement',
    name: 'integration_types.blacklist_placement',
  },
  {
    type: 'switch',
    label: 'Pause creative',
    name: 'integration_types.pause_creative',
  },
];

export const SOURCE_PRESETS_CONTACT_FIELDS = [
  {
    type: 'textField',
    label: 'Person',
    name: 'contact.person',
    placeholder: 'Person',
  },
  {
    type: 'textField',
    label: 'Email',
    name: 'contact.email',
    placeholder: 'Email',
  },
  {
    type: 'textField',
    label: 'Phone',
    name: 'contact.phone',
    placeholder: 'Phone',
  },
  {
    type: 'textField',
    label: 'Messenger',
    name: 'contact.messenger',
    placeholder: 'Messenger',
  },
  {
    type: 'textField',
    label: 'Referral link',
    name: 'referral_link',
    placeholder: 'Referral link',
  },
];

export const SOURCE_PRESETS_SETTINGS_FIELDS = [
  {
    type: 'textField',
    label: 'S2S postback',
    name: 'postback_url',
    placeholder: 'S2S postback',
  },
  {
    type: 'textField',
    label: 'Pixel postback',
    name: 'postback_pixel',
    placeholder: 'Pixel postback',
  },
  {
    type: 'textField',
    label: 'Imp ref id',
    name: 'imp_id',
    placeholder: 'Imp ref id',
  },
  {
    type: 'textField',
    label: 'Click ref id',
    name: 'ref_id',
    placeholder: 'Click ref id',
  },
  {
    type: 'textField',
    label: 'Imp cost id',
    name: 'imp_cost_id',
    placeholder: 'Imp cost id',
  },
  {
    type: 'textField',
    label: 'Click cost id',
    name: 'cost_id',
    placeholder: 'Click cost id',
  },
];
